const emptyLocale = {
  title: "No Data",
  actionText: "Action"
};
export {
  emptyLocale
};
//# sourceMappingURL=en_US.js.map
